import React from 'react';
import { recognizeItems } from '../data/content';
import { CtaButton } from './CtaButton';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-167" data-mp="30yj2png0hvzq">
      <div className="mx-auto max-w-4xl" data-id="element-168" data-mp="2w5ycsx08831h">
        <div className="text-center" data-id="element-169" data-mp="2w4x2iur1bkkt">
          <h2 className="font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-170" data-mp="2r7enqnqc6b4w">
            <span aria-hidden="true" data-id="element-171" data-mp="2m8tq8w2gy5k5">😰 </span>Ti riconosci in queste situazioni?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-172" data-mp="2i674ncwe5gve">
            Se hai risposto sì almeno una volta, questo pacchetto è per te.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-173" data-mp="2d7vqwr2z6m7w">
          {recognizeItems.map(item => <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-174" data-mp="28adl39k98n44">
              <span className="text-base leading-none" aria-hidden="true" data-id="element-175" data-mp="bfhc40vq9xvp">
                {item.emoji}
              </span>
              <span className="text-xs font-medium leading-snug text-ink/80" data-id="element-176" data-mp="3jl3mb8woglpx">{item.text}</span>
            </li>)}
        </ul>

        
      </div>
    </section>;
}